import { render, staticRenderFns } from "./email_dialog.vue?vue&type=template&id=0354a85e&scoped=true&"
import script from "./email_dialog.vue?vue&type=script&lang=js&"
export * from "./email_dialog.vue?vue&type=script&lang=js&"
import style0 from "./email_dialog.vue?vue&type=style&index=0&id=0354a85e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0354a85e",
  null
  
)

export default component.exports